import React from 'react';
import PropTypes from 'prop-types';
import Style from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Header from '@src/pc/layout/Header';
import MainImage from '@src/pc/layout/MainImage';
import VideoTabs from '@src/pc/layout/VideoTabs';
import Title from '@src/common/components/Title';
import ShortVideos from '@src/pc/layout/ShortVideos';
import Grid from '@src/pc/layout/Grid';
import Tabs from '@src/pc/layout/Tabs';
import Prev from '@src/pc/layout/Prev';
import Thanks from '@src/pc/layout/Thanks';
import Footer from '@src/pc/layout/Footer';
import { getModuleByName } from '@src/common/utils';

const Layout = ({ content }) => {
    const isShowNiceVideo = getModuleByName(content, '精彩短视频')?.display === 1;
    const isShowGoodLife = getModuleByName(content, '英雄人生')?.display === 1;
    const isShowLiveVideo = getModuleByName(content, '现场花絮')?.display === 1;
    const isShowThank = getModuleByName(content, '特别鸣谢')?.display === 1;

    return (
        <div className={Style.layout}>
            <Header />
            <MainImage />
            <div className={Style.bc}>
                <div className={Style.main}>
                    <VideoTabs content={content} />

                    {isShowNiceVideo ? (
                        <>
                            <Title title="精彩短视频" />
                            <ShortVideos content={content} />
                        </>
                    ) : null}

                    {isShowGoodLife ? (
                        <>
                            <Title title="英雄人生" />
                            <Grid content={content} />
                        </>
                    ) : null}

                    {isShowLiveVideo ? (
                        <>
                            <Title title="现场花絮" />
                            <Tabs content={content} />
                        </>
                    ) : null}
                    <Title title="往季回顾" />
                    <Prev content={content} />
                    {isShowThank ? (
                        <>
                            <Title title="特别鸣谢" />
                            <Thanks content={content} />
                        </>
                    ) : null}

                    <Title title="热门评论" />
                    <iframe
                        src={`http://widget.weibo.com/topics/topic_vote_base.php?uid=1894371930&border=0&footbar=1&width=821&height=369&refer=1&filter=1&language=zh_cn&version=base&dup=1&antispam=1&isOutTopicSearch=2&isshowright=1&tag=${encodeURIComponent(
                            '中国体育英雄联盟',
                        )}&og=${encodeURIComponent(
                            '【https://s.weibo.com/weibo?q=%23中国体育英雄联盟%23】',
                        )}&app_src=C0s9q&r=1577349024256`}
                        width="821"
                        height="665"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight="0"
                        loading="lazy"
                        style={{ display: 'block', margin: '0 auto' }}
                    />

                    <Footer />
                </div>
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
